/**
 * 3桁ごとにコンマで区切る
 * @param value
 * @returns {string}
 */
export const addFigure = (value) => {
    return String(value).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}
